import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { LANGUAGES } from "@/i18n";
import { useLocale } from "@/context/LocaleContext";
import { moneySymbol } from "@/lib/money";

const CURRENCIES = ["GBP", "USD", "EUR", "NGN", "GHS", "KES", "ZAR", "AED", "PHP", "JMD", "TTD", "XCD", "INR", "BRL", "CAD"];

export const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const locale = useLocale();
  const [open, setOpen] = useState(false);
  const lang = (i18n.language || "en").split("-")[0];

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" data-testid="locale-switcher-btn" aria-label="Language and currency">
          <Globe className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64 p-3" data-testid="locale-popover">
        <p className="mb-2 text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{t("common.language")}</p>
        <div className="grid grid-cols-2 gap-1">
          {LANGUAGES.map((l) => (
            <button key={l.code} onClick={() => { locale?.setLanguage(l.code); }}
              data-testid={`lang-option-${l.code}`}
              className={`flex items-center justify-between rounded-md px-2.5 py-1.5 text-left text-sm transition-colors hover:bg-secondary ${lang === l.code ? "bg-secondary font-medium" : "text-muted-foreground"}`}>
              {l.label}
              {lang === l.code && <Check className="h-3.5 w-3.5 text-primary" />}
            </button>
          ))}
        </div>
        <p className="mb-2 mt-4 text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{t("common.currency")}</p>
        <div className="grid grid-cols-3 gap-1">
          {CURRENCIES.map((c) => (
            <button key={c} onClick={() => locale?.setCurrency(c)}
              data-testid={`currency-option-${c}`}
              className={`rounded-md px-2 py-1.5 text-xs transition-colors hover:bg-secondary ${locale?.currency === c ? "bg-secondary font-semibold" : "text-muted-foreground"}`}>
              {moneySymbol(c).trim()} {c}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
